// extracted by mini-css-extract-plugin
export default {"spectraArray":"spectraArray_spectraArray__jXncY"};